import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { BlockUIModule } from 'primeng/blockui';
import { ToastModule } from 'primeng/toast';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { TableModule } from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton';
import { MessagesModule } from 'primeng/messages';
import { TagModule } from 'primeng/tag';
import { ImageModule } from 'primeng/image';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenubarModule } from 'primeng/menubar';
import { CardModule } from 'primeng/card';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MultiSelectModule } from 'primeng/multiselect';
import { MessageModule } from 'primeng/message';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { ListboxModule } from 'primeng/listbox';
import { ChipModule } from 'primeng/chip';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  exports: [
    InputTextModule,
    ButtonModule,
    BlockUIModule,
    ToastModule,
    InputNumberModule,
    InputMaskModule,
    CalendarModule,
    DropdownModule,
    FieldsetModule,
    TableModule,
    SkeletonModule,
    MessagesModule,
    TagModule,
    ImageModule,
    ConfirmDialogModule,
    CheckboxModule,
    IconFieldModule,
    InputIconModule,
    DialogModule,
    InputTextareaModule,
    MenubarModule,
    CardModule,
    PaginatorModule,
    ProgressSpinnerModule,
    InputSwitchModule,
    MultiSelectModule,
    MessageModule,
    AccordionModule,
    TooltipModule,
    MenuModule,
    ListboxModule,
    ChipModule,
  ]
})
export class PrimengModule { }
